import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 20842 14413"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#1c1b17;stroke-width:299.038}.fil0{fill:#2b2a29}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970277751040">
        <path
          d="M5939 150h8428L8621 7206l5746 7057H5939L193 7206z"
          className="fill stroke1"
          style={{
            strokeWidth: 299.038,
          }}
        />
        <path
          d="M17777 150h2750l-5746 7056 5746 7057h-2750l-5746-7057z"
          className="fill stroke1"
          style={{
            strokeWidth: 299.038,
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
